import BiocFacade from '@baidu/bioc-jssdk';

export const BIOC_AK = 'noJI6Jm2GJLsqWVVY9izmkLHwLVbahdz';

export const initCaptcha = (cb, isPassInit?: boolean) => {
    if (isPassInit) {
        cb && cb();
    } else {
        const captcha = BiocFacade.createCaptcha({ak: BIOC_AK});
        captcha.showPopup();
        captcha.onSuccess(token => {
            cb && cb(token.stk);
        });
    }
};